import React from 'react'
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  HashRouter,
  //  Link,
  Redirect
} from 'react-router-dom'
import { navElements } from '../../../config/constant'
import { hoverColor } from '../../../JS/setColors'
import { currentWidget } from '../../../action/action'

class userShortcut extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      viewUsrShortcuts: false,
      showComp: false,
      showCompPath: "/"
    }
  }
  // function to get list tobe displayed in "I WOULD LIKE TO"
  getShortcutList = () => {
    //we have to use alternative name provided by hotel not compName
    /*let array = [...this.props.navItems];
    let position1, position2, j, i, temp;
    for (j = 0; j < array.length; j++) {
      position1 = parseInt(array[j].position)
      for (i = 0; i < array.length; i++) {
        position2 = parseInt(array[j].position) ? parseInt(array[j].position) : 9999
        if (position2 < position1) {
          temp = array[j];
          array[j] = array[i];
          array[i] = temp;
        }
      }
    }
    return (
      array.map((iterator, index) => {
        if (iterator.include && index < 5) {
          return (
            <div onClick={() => { this.showCompOnClick(iterator.path) }}>
              {iterator.compName || "UNKNOWN"}
              <i className="fa fa-chevron-right">
                <img
                  className="arrow"
                  src={require('../../../images/icon/arrow.svg')}
                  alt="" />
              </i>
            </div>
          )
        }
      })
    )*/
    return (
      this.props.navItems.map((iterator, index) => {
        if (index < 4) {
          return (
            <div
              onClick={() => { this.showCompOnClick(iterator.path, iterator) }}
              style={{ color: "inherit" }}
              className="shortcutKeyHover"
            >
              {iterator.displayName || "UNKNOWN"}
              <a href="#" style={{ color: "inherit" }}>
                <i className="fa fa-chevron-right" style={{ color: "inherit" }}>
                </i>
              </a>
            </div>
          )
        }
      }
      )
    )
  }

  componentDidUpdate() {
    hoverColor('.shortcutKeyHover', this.props.menuColor);
  }

  componentDidMount() {
    hoverColor('.shortcutKeyHover', this.props.menuColor);
  }
  //this method useful in future
  showUsrShortcuts = () => {
    this.setState({ viewUsrShortcuts: !this.state.viewUsrShortcuts })
  }
  // function will set component path to witch we will redirect 
  showCompOnClick = (path, widget) => {
    this.setState({
      showCompPath: path,
      showComp: true
    })
    this.props.currentWidget(widget);
  }

  render() {
    return (
      <div id="usrShortcuts" className="widget col col-2 h-auto m-r25">
        <div className="widget-contents">
          <div className="widget-heading">
            {this.props.stringConst.iWould}
          </div>
          <div
            id="viewAllShortcut"
            className="widget-body"
            style={{ padding: 0 }}>
            <div className="shortcuts">
              {
                this.getShortcutList()
              }
              {this.state.showComp ?
                <HashRouter>
                  <Redirect to={this.state.showCompPath} />
                </HashRouter>
                : ""
              }
            </div>
          </div>
          {/* <div
            className="widget-btn-main view-all"
            onClick={this.showUsrShortcuts}>
            {this.props.stringConst.viewAll}
            <i class="fa fa-plus" style={{ color: "inherit" }}></i>
          </div> */}
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    navItems: state.store.sideNavBar.navItems,
    stringConst: state.store.home.stringConst,
    menuColor: state.store.home.MenuColor
  }
}

userShortcut.propTypes = {
  navItems: propTypes.arrayOf(propTypes.object),
  stringConst: propTypes.object
}


export default connect(
  mapStateToProps,
  {
    currentWidget
  }
)(userShortcut);